<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>Create Coaching Chat</v-toolbar-title>
      <v-spacer />
      <v-btn icon dark @click="$emit('closed')">
        <v-icon color="navy">mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <div class="pa-4">
      <v-alert type="info" outlined
        >This creates a new COACH Chat between the user and the selected coach below.</v-alert
      >
      <staff-picker label="Coach" :selected="chat.creatorId" @change="chat.creatorId = $event" />
      <v-textarea v-model="chat.description" placeholder="Description (optional)" auto-grow outlined dense rows="5" />

      <v-btn color="secondary" outlined @click="save">Save Chat</v-btn>
    </div>
  </v-card>
</template>

<script>
import StaffPicker from "@/components/shared/StaffPicker";
import { CREATE_CLUB_COACH_CHAT_MUTATION } from "@/graphql/mutations/chat";

export default {
  name: "CreateCoachingChatCard",
  components: { StaffPicker },
  props: {
    userId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      chat: {
        creatorId: null,
        description: null,
      },
    };
  },
  methods: {
    async save() {
      await this.$apollo.mutate({
        mutation: CREATE_CLUB_COACH_CHAT_MUTATION,
        variables: {
          userId: this.userId,
          coachId: this.chat.creatorId,
          description: this.chat.description,
        },
      });
      this.$emit("saved");
    },
  },
};
</script>
